// Translations for SmartLogis - FR, EN, ES
export const translations = {
  fr: {
    // Header
    home: "Accueil",
    products: "Produits",
    services: "Services",
    reservation: "Réservation",
    contact: "Contact",
    reserve: "Réserver",
    
    // Hero
    heroTag: "🏠 Domotique pour Locataires",
    heroTitle1: "Transformez votre",
    heroTitle2: "appartement",
    heroTitle3: "en maison intelligente",
    heroDescription: "Des kits portables et abordables pour rendre votre logement locatif intelligent. Installation professionnelle à Montréal et ses environs.",
    heroFeature1: "Aucune modification permanente",
    heroFeature2: "Emportez tout lors du déménagement",
    heroFeature3: "Installation en moins de 3 heures",
    discoverKits: "Découvrir nos Kits",
    reserveInstallation: "Réserver Installation",
    installations: "Installations",
    satisfaction: "Satisfaction",
    warranty: "Garantie",
    years: "ans",
    
    // Products
    ourProducts: "Nos Produits",
    productsTitle: "Kits et Accessoires Intelligents",
    productsSubtitle: "Choisissez le kit parfait pour votre logement ou composez votre solution sur mesure",
    all: "Tous",
    completeKits: "Kits Complets",
    accessories: "Accessoires",
    popular: "Populaire",
    order: "Commander",
    
    // Product descriptions
    kitBeginner: "Kit Débutant",
    kitBeginnerDesc: "Parfait pour commencer votre maison intelligente",
    kitComfort: "Kit Confort",
    kitComfortDesc: "Solution complète pour votre appartement",
    kitPremium: "Kit Premium",
    kitPremiumDesc: "L'expérience domotique ultime",
    
    smartBulb: "Ampoule Intelligente",
    smartBulbDesc: "16 millions de couleurs, contrôle vocal",
    smartPlug: "Prise Connectée",
    smartPlugDesc: "Contrôlez vos appareils à distance",
    smartCamera: "Caméra de Sécurité Intelligente",
    smartCameraDesc: "Surveillez votre domicile en temps réel",
    smartLock: "Serrure Intelligente (Smart Lock)",
    smartLockDesc: "Sécurisez votre porte d'entrée",
    
    // Features
    smartBulbs: "ampoules intelligentes",
    smartPlug: "prise connectée",
    smartPlugs: "prises connectées",
    motionSensor: "capteur de mouvement",
    sensors: "capteurs",
    curtainMotor: "moteur de rideau",
    curtainMotors: "moteurs de rideaux",
    hub: "Hub (Cerveau intelligent)",
    professionalInstallation: "Installation professionnelle incluse",
    compatibleAlexa: "Compatible Alexa/Google/Apple",
    wifiBuiltIn: "WiFi intégré",
    energySaving: "Économie d'énergie",
    nightVision: "Vision nocturne HD",
    motionDetection: "Détection de mouvement",
    twoWayAudio: "Communication audio bidirectionnelle",
    instantNotifications: "Notifications instantanées",
    cloudRecording: "Enregistrement cloud",
    codeUnlock: "Déverrouillage par code/app",
    accessHistory: "Historique d'accès",
    noDrilling: "Installation sans perçage",
    guestAccess: "Accès invités temporaires",
    scheduling: "Programmation horaire",
    consumptionTracking: "Suivi consommation",
    remoteControl: "Contrôle à distance",
    easyInstall: "Installation facile",
    silent: "Silencieux",
    programmable: "Programmable",
    
    // Products - Kit Names and Descriptions (UPDATED)
    kitDebutantName: "Kit Débutant",
    kitDebutantDesc: "Solution parfaite pour commencer",
    kitIntermediateName: "Kit Intermédiaire",
    kitIntermediateDesc: "Solution complète pour votre maison",
    kitCompletoName: "Kit Completo",
    kitCompletoDesc: "L'expérience domotique complète",
    
    // Smart Lock Individual
    smartLockIndividualName: "Serrure Intelligente (Chapa)",
    smartLockIndividualDesc: "Sécurisez votre porte d'entrée",
    installationNotIncluded: "⚠️ L'installation n'est pas incluse",
    
    // Kit Items
    item4SmartBulbs: "4 Ampoules intelligentes",
    item8SmartBulbs: "8 Ampoules intelligentes",
    item12SmartBulbs: "12 Ampoules intelligentes",
    item2SmartPlugs: "2 Prises intelligentes",
    item3SmartPlugs: "3 Prises intelligentes",
    item4SmartPlugs: "4 Prises intelligentes",
    item2MotionSensors: "2 Capteurs de mouvement",
    item3MotionSensors: "3 Capteurs de mouvement",
    item4MotionSensors: "4 Capteurs de mouvement",
    item1Hub: "1 Hub (Cerveau intelligent)",
    item1RemoteControl: "1 Télécommande",
    item1IndoorCamera: "1 Caméra intérieure",
    installationIncluded: "✓ Installation incluse",
    
    // Accessories
    smartCameraName: "Caméra de Sécurité Intelligente",
    smartCameraDesc: "Surveillez votre domicile en temps réel",
    smartLockName: "Serrure Intelligente (Smart Lock)",
    smartLockDesc: "Sécurisez votre porte d'entrée",
    
    // Product Features
    smartLock: "Serrure intelligente",
    smartCamera: "1 caméra intelligente",
    smartCamera2: "2 caméras intelligentes",
    smartThermostat: "Thermostat intelligent",
    easySetup: "Installation facile",
    mobileApp: "Application mobile",
    hd1080p: "HD 1080p",
    audioDetection: "Détection audio",
    cloudStorage: "Stockage cloud",
    keylessEntry: "Entrée sans clé",
    remoteAccess: "Accès à distance",
    activityLog: "Historique d'activité",
    
    // Service durations
    
    // Image Disclaimer
    imageDisclaimer: "Les images sont à titre illustratif seulement et peuvent ne pas refléter le produit final.",
    duration23hours: "2-3 heures",
    duration34hours: "3-4 heures",
    duration1hour: "1 heure",
    professionalInstallation: "Installation professionnelle",
    
    
    // Form labels and placeholders
    fullName: "Nom complet",
    fullNamePlaceholder: "Jean Dupont",
    emailPlaceholder: "jean@exemple.com",
    phone: "Téléphone",
    phonePlaceholder: "(514) 555-1234",
    address: "Adresse complète",
    addressPlaceholder: "123 Rue Example, Montréal, QC H1A 1A1",
    confirmReservation: "Confirmer la Réservation",
    bookYourInstallation: "Réservez Votre Installation",
    chooseDateTime: "Choisissez la date et l'heure qui vous conviennent pour l'installation de votre kit",
    installationIn: "Installation en",
    professionalServiceGuarantee: "Service professionnel garanti",
    // Custom Kits
    customKitsTitle: "Besoin d'une Solution Sur Mesure?",
    customKitsSubtitle: "Kits personnalisés disponibles sur demande",
    customKitsDescription: "Nous créons des kits adaptés à vos besoins spécifiques. Que vous ayez besoin de plus de caméras, de serrures intelligentes ou d'une configuration unique, notre équipe est là pour vous aider.",
    requestCustomQuote: "Demander un Devis Personnalisé",
    
    // Services
    ourServices: "Nos Services",
    servicesTitle: "Service d'Installation Seule",
    servicesSubtitle: "Si vous avez déjà vos équipements, nous nous occupons de l'installation professionnelle",
    installationIn: "Installation en 2-3 Heures",
    professionalServiceGuarantee: "Service professionnel avec garantie satisfaction",
    
    standardInstallation: "Installation Standard",
    standardInstallationDesc: "Installation complète de votre kit",
    premiumInstallation: "Installation Premium",
    premiumInstallationDesc: "Service complet avec personnalisation",
    remoteConfiguration: "Configuration À Distance",
    remoteConfigurationDesc: "Assistance en ligne pour configuration",
    mostPopular: "Plus Populaire",
    reserveService: "Réserver ce Service",
    
    // Service features
    deviceInstallation: "Installation de tous les appareils",
    networkConfig: "Configuration du réseau",
    basicTraining: "Formation de base",
    support30days: "Support 30 jours",
    allStandard: "Tout du service standard",
    advancedConfig: "Configuration avancée",
    customScenarios: "Scénarios personnalisés",
    completeTraining: "Formation complète",
    support90days: "Support 90 jours",
    liveVideoSupport: "Support vidéo en direct",
    softwareConfig: "Configuration logicielle",
    personalizedGuide: "Guide personnalisé",
    support14days: "Support 14 jours",
    
    whyChooseUs: "Pourquoi Choisir SmartLogis?",
    localExpertise: "Expertise Locale",
    localExpertiseDesc: "Spécialistes de la domotique pour locataires dans la région de Montréal",
    quickInstallation: "Installation Rapide",
    quickInstallationDesc: "Installation complète en quelques heures, sans modification permanente",
    continuousSupport: "Support Continu",
    continuousSupportDesc: "Assistance technique incluse et garantie satisfaction 100%",
    
    // Reservation
    reserveYourInstallation: "Réservez Votre Installation",
    reservationSubtitle: "Choisissez la date et l'heure qui vous conviennent pour l'installation de votre kit",
    selectDateTime: "Sélectionnez Date & Heure",
    appointmentTime: "Heure de rendez-vous",
    reservationInfo: "Informations de Réservation",
    desiredService: "Service souhaité",
    chooseService: "Choisissez un service",
    serviceArea: "Zone de service",
    selectCity: "Sélectionnez votre ville",
    fullName: "Nom complet",
    email: "Email",
    phone: "Téléphone",
    fullAddress: "Adresse complète",
    confirmReservation: "Confirmer la Réservation",
    allFieldsRequired: "* Tous les champs sont obligatoires. Vous recevrez une confirmation par email.",
    fillAllFields: "Veuillez remplir tous les champs",
    reservationConfirmed: "Réservation confirmée! Numéro:",
    confirmationEmailSent: "Un email de confirmation a été envoyé (vérifiez les logs serveur)",
    reservationError: "Erreur lors de la réservation. Veuillez réessayer.",
    duration: "Durée",
    free: "Gratuit",
    
    // Reservation services
    reservationKitBeginner: "Kit Débutant",
    reservationKitComfort: "Kit Confort",
    reservationKitPremium: "Kit Premium",
    reservationCustomKit: "Soumission Kit Personnalisé",
    reservationInstallOnly: "Installation seule (Équipement client)",
    reservationPremiumInstallClient: "Installation Premium (Équipement client)",
    reservationRemoteConfig: "Configuration à Distance",
    
    // Contact
    contactUs: "Contactez-Nous",
    contactTitle: "Contactez-Nous",
    contactSubtitle: "Une question? Besoin d'un devis? Notre équipe est là pour vous aider",
    quoteRequest: "Demande de Devis",
    subject: "Sujet",
    message: "Message",
    sendMessage: "Envoyer le Message",
    phoneLabel: "Téléphone",
    emailLabel: "Email",
    serviceZone: "Zone de Service",
    responseIn24h: "Réponse en 24h",
    monFri9to6: "Lun-Ven: 9h-18h",
    and30kmAround: "et environs (30km)",
    customerTestimonials: "Témoignages Clients",
    faq: "Questions Fréquentes",
    messageSent: "Message envoyé! Nous vous répondrons sous 24h.",
    notificationSent: "Une notification a été envoyée à ventes@smartlogis.ca (vérifiez les logs serveur)",
    messageError: "Erreur lors de l'envoi du message. Veuillez réessayer.",
    
    // FAQ
    faqCanITake: "Puis-je emporter mon kit si je déménage?",
    faqCanITakeAnswer: "Absolument! C'est l'avantage principal de nos kits. Tous nos produits sont portables et peuvent être facilement retirés et réinstallés dans votre nouveau logement.",
    faqLandlordPermission: "Ai-je besoin d'autorisation de mon propriétaire?",
    faqLandlordPermissionAnswer: "Non, nos installations ne nécessitent aucune modification permanente. Aucune autorisation n'est requise car tout peut être retiré sans trace.",
    faqServiceArea: "Quelle est la zone de service?",
    faqServiceAreaAnswer: "Nous desservons Montréal et ses environs (Laval, Longueuil, Rive-Nord, Rive-Sud). Contactez-nous pour confirmer votre adresse.",
    faqWarranty: "Offrez-vous une garantie?",
    faqWarrantyAnswer: "Oui, tous nos produits sont garantis 2 ans. Notre service d'installation inclut également un support technique gratuit.",
    faqSelfInstall: "Puis-je installer moi-même?",
    faqSelfInstallAnswer: "Oui! Nos kits sont conçus pour être faciles à installer. Mais nous recommandons notre service d'installation pour une expérience optimale et une configuration personnalisée.",
    
    // Footer
    smartHomeSolutions: "Solutions de maison intelligente portables et abordables pour locataires à Montréal et ses environs.",
    quickLinks: "Liens Rapides",
    quebec: "Québec",
    canada: "Canada",
    privacyPolicy: "Politique de Confidentialité",
    termsOfUse: "Conditions d'Utilisation",
    allRightsReserved: "Tous droits réservés.",

    // Kit Configurator
    configuratorTitle: "Créez votre kit sur mesure",
    configuratorSubtitle: "Choisissez vos appareils, voyez le prix en temps réel, puis commandez via WhatsApp.",
    ourKits: "Nos Kits",
    starterKit: "Kit Débutant",
    intermediateKit: "Kit Intermédiaire",
    completeKit: "Kit Complet",
    customizeYourKit: "Personnalisez votre Kit",
    smartHub: "Hub intelligent",
    sensor: "Capteur",
    remote: "Télécommande",
    smartBulbConfig: "Ampoule intelligente",
    smartPlugConfig: "Prise intelligente",
    quantity: "Quantité",
    installationOptions: "Options d'Installation",
    basicInstallation: "Installation simple (1–2 appareils)",
    fullInstallation: "Installation complète",
    totalPrice: "Total",
    orderViaWhatsApp: "Commander via WhatsApp",
    videoDemo: "Vidéo Démo",
    whatsappGreeting: "Bonjour SmartLogis ! Je souhaite commander :",
    whatsappTotal: "Total :",
    whatsappThanks: "Merci !",
  },
  
  en: {
    // Header
    home: "Home",
    products: "Products",
    services: "Services",
    reservation: "Reservation",
    contact: "Contact",
    reserve: "Reserve",
    
    // Hero
    heroTag: "🏠 Smart Home for Renters",
    heroTitle1: "Transform your",
    heroTitle2: "apartment",
    heroTitle3: "into a smart home",
    heroDescription: "Portable and affordable kits to make your rental property smart. Professional installation in Montreal and surrounding areas.",
    heroFeature1: "No permanent modifications",
    heroFeature2: "Take everything when you move",
    heroFeature3: "Installation in under 3 hours",
    discoverKits: "Discover our Kits",
    reserveInstallation: "Reserve Installation",
    installations: "Installations",
    satisfaction: "Satisfaction",
    warranty: "Warranty",
    years: "years",
    
    // Products
    ourProducts: "Our Products",
    productsTitle: "Smart Kits and Accessories",
    productsSubtitle: "Choose the perfect kit for your home or create your custom solution",
    all: "All",
    completeKits: "Complete Kits",
    accessories: "Accessories",
    popular: "Popular",
    order: "Order",
    
    // Product descriptions
    kitBeginner: "Starter Kit",
    kitBeginnerDesc: "Perfect to start your smart home",
    kitComfort: "Comfort Kit",
    kitComfortDesc: "Complete solution for your apartment",
    kitPremium: "Premium Kit",
    kitPremiumDesc: "The ultimate smart home experience",
    
    smartBulb: "Smart Bulb",
    smartBulbDesc: "16 million colors, voice control",
    smartPlug: "Smart Plug",
    smartPlugDesc: "Control your devices remotely",
    smartCamera: "Smart Security Camera",
    smartCameraDesc: "Monitor your home in real-time",
    smartLock: "Smart Lock",
    
    // Products - Kit Names and Descriptions (UPDATED)
    kitDebutantName: "Starter Kit",
    kitDebutantDesc: "Perfect solution to get started",
    kitIntermediateName: "Intermediate Kit",
    kitIntermediateDesc: "Complete solution for your home",
    kitCompletoName: "Complete Kit",
    kitCompletoDesc: "The complete home automation experience",
    
    // Smart Lock Individual
    smartLockIndividualName: "Smart Lock (Chapa)",
    smartLockIndividualDesc: "Secure your front door",
    installationNotIncluded: "⚠️ Installation NOT included",
    
    // Kit Items
    item4SmartBulbs: "4 Smart Bulbs",
    item8SmartBulbs: "8 Smart Bulbs",
    item12SmartBulbs: "12 Smart Bulbs",
    item2SmartPlugs: "2 Smart Plugs",
    item3SmartPlugs: "3 Smart Plugs",
    item4SmartPlugs: "4 Smart Plugs",
    item2MotionSensors: "2 Motion Sensors",
    item3MotionSensors: "3 Motion Sensors",
    item4MotionSensors: "4 Motion Sensors",
    item1Hub: "1 Hub (Smart Brain)",
    item1RemoteControl: "1 Remote Control",
    item1IndoorCamera: "1 Indoor Camera",
    installationIncluded: "✓ Installation included",
    
    // Accessories
    smartCameraName: "Smart Security Camera",
    smartCameraDesc: "Monitor your home in real-time",
    smartLockName: "Smart Lock",
    smartLockDesc: "Secure your front door",
    
    // Product Features
    smartLock: "Smart lock",
    smartCamera: "1 smart camera",
    smartCamera2: "2 smart cameras",
    smartThermostat: "Smart thermostat",
    easySetup: "Easy setup",
    mobileApp: "Mobile app",
    hd1080p: "HD 1080p",
    audioDetection: "Audio detection",
    cloudStorage: "Cloud storage",
    keylessEntry: "Keyless entry",
    remoteAccess: "Remote access",
    activityLog: "Activity log",
    smartLockDesc: "Secure your front door",
    
    // Features
    smartBulbs: "smart bulbs",
    smartPlug: "smart plug",
    smartPlugs: "smart plugs",
    motionSensor: "motion sensor",
    sensors: "sensors",
    curtainMotor: "curtain motor",
    curtainMotors: "curtain motors",
    hub: "Hub (Smart Brain)",
    professionalInstallation: "Professional installation included",
    compatibleAlexa: "Compatible Alexa/Google/Apple",
    wifiBuiltIn: "Built-in WiFi",
    
    // Form labels and placeholders
    fullName: "Full Name",
    fullNamePlaceholder: "John Doe",
    emailPlaceholder: "john@example.com",
    phone: "Phone",
    phonePlaceholder: "(514) 555-1234",
    address: "Full Address",
    addressPlaceholder: "123 Example St, Montreal, QC H1A 1A1",
    confirmReservation: "Confirm Reservation",
    bookYourInstallation: "Book Your Installation",
    chooseDateTime: "Choose the date and time that work for you for your kit installation",
    installationIn: "Installation in",
    professionalServiceGuarantee: "Professional service guaranteed",
    energySaving: "Energy saving",
    nightVision: "HD night vision",
    motionDetection: "Motion detection",
    twoWayAudio: "Two-way audio communication",
    instantNotifications: "Instant notifications",
    cloudRecording: "Cloud recording",
    codeUnlock: "Code/app unlock",
    accessHistory: "Access history",
    noDrilling: "No-drill installation",
    guestAccess: "Temporary guest access",
    scheduling: "Time scheduling",
    consumptionTracking: "Consumption tracking",
    remoteControl: "Remote control",
    
    // Service durations
    duration23hours: "2-3 hours",
    duration34hours: "3-4 hours",
    duration1hour: "1 hour",
    professionalInstallation: "Professional Installation",
    easyInstall: "Easy installation",
    silent: "Silent",
    programmable: "Programmable",
    
    // Custom Kits
    customKitsTitle: "Need a Custom Solution?",
    customKitsSubtitle: "Custom kits available on request",
    customKitsDescription: "We create kits tailored to your specific needs. Whether you need more cameras, smart locks, or a unique configuration, our team is here to help.",
    requestCustomQuote: "Request Custom Quote",
    
    // Services
    ourServices: "Our Services",
    servicesTitle: "Installation Service Only",
    servicesSubtitle: "If you already have your equipment, we handle the professional installation",
    installationIn: "Installation in 2-3 Hours",
    professionalServiceGuarantee: "Professional service with satisfaction guarantee",
    
    standardInstallation: "Standard Installation",
    standardInstallationDesc: "Complete installation of your kit",
    premiumInstallation: "Premium Installation",
    premiumInstallationDesc: "Full service with customization",
    remoteConfiguration: "Remote Configuration",
    remoteConfigurationDesc: "Online assistance for configuration",
    mostPopular: "Most Popular",
    reserveService: "Reserve this Service",
    
    // Service features
    deviceInstallation: "All device installation",
    networkConfig: "Network configuration",
    basicTraining: "Basic training",
    support30days: "30-day support",
    allStandard: "All standard features",
    advancedConfig: "Advanced configuration",
    customScenarios: "Custom scenarios",
    completeTraining: "Complete training",
    support90days: "90-day support",
    liveVideoSupport: "Live video support",
    softwareConfig: "Software configuration",
    personalizedGuide: "Personalized guide",
    support14days: "14-day support",
    
    whyChooseUs: "Why Choose SmartLogis?",
    localExpertise: "Local Expertise",
    localExpertiseDesc: "Smart home specialists for renters in the Montreal area",
    quickInstallation: "Quick Installation",
    quickInstallationDesc: "Complete installation in a few hours, no permanent modifications",
    continuousSupport: "Continuous Support",
    continuousSupportDesc: "Technical assistance included and 100% satisfaction guarantee",
    
    // Reservation
    reserveYourInstallation: "Reserve Your Installation",
    reservationSubtitle: "Choose the date and time that works for you for your kit installation",
    selectDateTime: "Select Date & Time",
    appointmentTime: "Appointment time",
    reservationInfo: "Reservation Information",
    desiredService: "Desired service",
    chooseService: "Choose a service",
    serviceArea: "Service area",
    selectCity: "Select your city",
    fullName: "Full name",
    email: "Email",
    phone: "Phone",
    fullAddress: "Full address",
    confirmReservation: "Confirm Reservation",
    allFieldsRequired: "* All fields are required. You will receive a confirmation email.",
    fillAllFields: "Please fill in all fields",
    reservationConfirmed: "Reservation confirmed! Number:",
    confirmationEmailSent: "A confirmation email has been sent (check server logs)",
    reservationError: "Reservation error. Please try again.",
    duration: "Duration",
    free: "Free",
    
    // Reservation services
    reservationKitBeginner: "Starter Kit",
    reservationKitComfort: "Comfort Kit",
    reservationKitPremium: "Premium Kit",
    reservationCustomKit: "Custom Kit Quote",
    reservationInstallOnly: "Installation Only (Customer Equipment)",
    reservationPremiumInstallClient: "Premium Installation (Customer Equipment)",
    reservationRemoteConfig: "Remote Configuration",
    
    // Contact
    contactUs: "Contact Us",
    contactTitle: "Contact Us",
    contactSubtitle: "Have a question? Need a quote? Our team is here to help",
    quoteRequest: "Quote Request",
    subject: "Subject",
    message: "Message",
    sendMessage: "Send Message",
    phoneLabel: "Phone",
    emailLabel: "Email",
    serviceZone: "Service Area",
    responseIn24h: "24h response",
    monFri9to6: "Mon-Fri: 9am-6pm",
    and30kmAround: "and surroundings (30km)",
    customerTestimonials: "Customer Testimonials",
    faq: "Frequently Asked Questions",
    messageSent: "Message sent! We will respond within 24 hours.",
    notificationSent: "A notification has been sent to ventes@smartlogis.ca (check server logs)",
    messageError: "Error sending message. Please try again.",
    
    // FAQ
    faqCanITake: "Can I take my kit when I move?",
    faqCanITakeAnswer: "Absolutely! That's the main advantage of our kits. All our products are portable and can be easily removed and reinstalled in your new home.",
    faqLandlordPermission: "Do I need landlord permission?",
    faqLandlordPermissionAnswer: "No, our installations require no permanent modifications. No permission is needed as everything can be removed without a trace.",
    faqServiceArea: "What is the service area?",
    faqServiceAreaAnswer: "We serve Montreal and surrounding areas (Laval, Longueuil, North Shore, South Shore). Contact us to confirm your address.",
    faqWarranty: "Do you offer a warranty?",
    faqWarrantyAnswer: "Yes, all our products come with a 2-year warranty. Our installation service also includes free technical support.",
    faqSelfInstall: "Can I install it myself?",
    faqSelfInstallAnswer: "Yes! Our kits are designed to be easy to install. But we recommend our installation service for an optimal experience and personalized configuration.",
    
    // Footer
    smartHomeSolutions: "Portable and affordable smart home solutions for renters in Montreal and surrounding areas.",
    quickLinks: "Quick Links",
    quebec: "Quebec",
    canada: "Canada",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
    allRightsReserved: "All rights reserved.",

    // Kit Configurator
    configuratorTitle: "Build your custom kit",
    configuratorSubtitle: "Choose your devices, see the price in real time, then order via WhatsApp.",
    ourKits: "Our Kits",
    starterKit: "Starter Kit",
    intermediateKit: "Intermediate Kit",
    completeKit: "Complete Kit",
    customizeYourKit: "Customize Your Kit",
    smartHub: "Smart Hub",
    sensor: "Sensor",
    remote: "Remote",
    smartBulbConfig: "Smart Bulb",
    smartPlugConfig: "Smart Plug",
    quantity: "Quantity",
    installationOptions: "Installation Options",
    basicInstallation: "Basic installation (1–2 devices)",
    fullInstallation: "Full installation",
    totalPrice: "Total",
    orderViaWhatsApp: "Order via WhatsApp",
    videoDemo: "Video Demo",
    whatsappGreeting: "Hello SmartLogis! I'd like to order:",
    whatsappTotal: "Total:",
    whatsappThanks: "Thank you!",
  },
  
  es: {
    // Header
    home: "Inicio",
    products: "Productos",
    services: "Servicios",
    reservation: "Reserva",
    contact: "Contacto",
    reserve: "Reservar",
    
    // Hero
    heroTag: "🏠 Domótica para Inquilinos",
    heroTitle1: "Transforme su",
    heroTitle2: "apartamento",
    heroTitle3: "en una casa inteligente",
    heroDescription: "Kits portátiles y asequibles para hacer inteligente su vivienda de alquiler. Instalación profesional en Montreal y alrededores.",
    heroFeature1: "Sin modificaciones permanentes",
    heroFeature2: "Llévelo todo cuando se mude",
    heroFeature3: "Instalación en menos de 3 horas",
    discoverKits: "Descubra nuestros Kits",
    reserveInstallation: "Reservar Instalación",
    installations: "Instalaciones",
    satisfaction: "Satisfacción",
    warranty: "Garantía",
    years: "años",
    
    // Products
    ourProducts: "Nuestros Productos",
    productsTitle: "Kits y Accesorios Inteligentes",
    productsSubtitle: "Elija el kit perfecto para su hogar o cree su solución personalizada",
    all: "Todos",
    completeKits: "Kits Completos",
    accessories: "Accesorios",
    popular: "Popular",
    order: "Ordenar",
    
    // Product descriptions
    kitBeginner: "Kit Inicial",
    kitBeginnerDesc: "Perfecto para comenzar su hogar inteligente",
    kitComfort: "Kit Confort",
    kitComfortDesc: "Solución completa para su apartamento",
    kitPremium: "Kit Premium",
    
    // Image Disclaimer
    imageDisclaimer: "Las imágenes son solo ilustrativas y pueden no reflejar el producto final.",
    kitPremiumDesc: "La experiencia domótica definitiva",
    
    smartBulb: "Bombilla Inteligente",
    smartBulbDesc: "16 millones de colores, control por voz",
    smartPlug: "Enchufe Inteligente",
    smartPlugDesc: "Controle sus dispositivos remotamente",
    
    // Products - Kit Names and Descriptions (UPDATED)
    kitDebutantName: "Kit Inicial",
    kitDebutantDesc: "Solución perfecta para comenzar",
    kitIntermediateName: "Kit Intermedio",
    kitIntermediateDesc: "Solución completa para tu hogar",
    kitCompletoName: "Kit Completo",
    kitCompletoDesc: "La experiencia domótica completa",
    
    // Smart Lock Individual
    smartLockIndividualName: "Cerradura Inteligente (Chapa)",
    smartLockIndividualDesc: "Asegura tu puerta principal",
    installationNotIncluded: "⚠️ Instalación no incluida",
    
    // Kit Items
    item4SmartBulbs: "4 Bombillas inteligentes",
    item8SmartBulbs: "8 Bombillas inteligentes",
    item12SmartBulbs: "12 Bombillas inteligentes",
    item2SmartPlugs: "2 Enchufes inteligentes",
    item3SmartPlugs: "3 Enchufes inteligentes",
    item4SmartPlugs: "4 Enchufes inteligentes",
    item2MotionSensors: "2 Sensores de movimiento",
    item3MotionSensors: "3 Sensores de movimiento",
    item4MotionSensors: "4 Sensores de movimiento",
    item1Hub: "1 Hub (Cerebro inteligente)",
    item1RemoteControl: "1 Control remoto",
    item1IndoorCamera: "1 Cámara interior",
    installationIncluded: "✓ Instalación incluida",
    
    // Accessories
    smartCameraName: "Cámara de Seguridad Inteligente",
    smartCameraDesc: "Monitorea tu hogar en tiempo real",
    smartLockName: "Cerradura Inteligente",
    smartLockDesc: "Asegura tu puerta principal",
    
    // Product Features
    smartLock: "Cerradura inteligente",
    smartCamera: "1 cámara inteligente",
    smartCamera2: "2 cámaras inteligentes",
    smartThermostat: "Termostato inteligente",
    easySetup: "Configuración fácil",
    mobileApp: "Aplicación móvil",
    hd1080p: "HD 1080p",
    audioDetection: "Detección de audio",
    cloudStorage: "Almacenamiento en la nube",
    keylessEntry: "Entrada sin llave",
    remoteAccess: "Acceso remoto",
    activityLog: "Registro de actividad",
    smartCamera: "Cámara de Seguridad Inteligente",
    smartCameraDesc: "Vigile su hogar en tiempo real",
    smartLock: "Cerradura Inteligente",
    smartLockDesc: "Asegure su puerta principal",
    
    // Features
    smartBulbs: "bombillas inteligentes",
    smartPlug: "enchufe inteligente",
    
    // Form labels and placeholders
    fullName: "Nombre completo",
    fullNamePlaceholder: "Juan Pérez",
    emailPlaceholder: "juan@ejemplo.com",
    phone: "Teléfono",
    phonePlaceholder: "(514) 555-1234",
    address: "Dirección completa",
    addressPlaceholder: "123 Calle Ejemplo, Montreal, QC H1A 1A1",
    confirmReservation: "Confirmar Reserva",
    bookYourInstallation: "Reserve Su Instalación",
    chooseDateTime: "Elija la fecha y hora que le convenga para la instalación de su kit",
    installationIn: "Instalación en",
    professionalServiceGuarantee: "Servicio profesional garantizado",
    smartPlugs: "enchufes inteligentes",
    motionSensor: "sensor de movimiento",
    sensors: "sensores",
    curtainMotor: "motor de cortina",
    curtainMotors: "motores de cortina",
    hub: "Hub (Cerebro inteligente)",
    professionalInstallation: "Instalación profesional incluida",
    
    // Service durations
    duration23hours: "2-3 horas",
    duration34hours: "3-4 horas",
    duration1hour: "1 hora",
    professionalInstallation: "Instalación profesional",
    compatibleAlexa: "Compatible Alexa/Google/Apple",
    wifiBuiltIn: "WiFi integrado",
    energySaving: "Ahorro de energía",
    nightVision: "Visión nocturna HD",
    motionDetection: "Detección de movimiento",
    twoWayAudio: "Comunicación de audio bidireccional",
    instantNotifications: "Notificaciones instantáneas",
    cloudRecording: "Grabación en la nube",
    codeUnlock: "Desbloqueo por código/app",
    accessHistory: "Historial de acceso",
    noDrilling: "Instalación sin taladrar",
    guestAccess: "Acceso temporal para invitados",
    scheduling: "Programación horaria",
    consumptionTracking: "Seguimiento de consumo",
    remoteControl: "Control remoto",
    easyInstall: "Instalación fácil",
    silent: "Silencioso",
    programmable: "Programable",
    
    // Custom Kits
    customKitsTitle: "¿Necesita una Solución Personalizada?",
    customKitsSubtitle: "Kits personalizados disponibles bajo pedido",
    customKitsDescription: "Creamos kits adaptados a sus necesidades específicas. Ya sea que necesite más cámaras, cerraduras inteligentes o una configuración única, nuestro equipo está aquí para ayudarle.",
    requestCustomQuote: "Solicitar Cotización Personalizada",
    
    // Services
    ourServices: "Nuestros Servicios",
    servicesTitle: "Servicio de Instalación Solamente",
    servicesSubtitle: "Si ya tiene su equipo, nos encargamos de la instalación profesional",
    installationIn: "Instalación en 2-3 Horas",
    professionalServiceGuarantee: "Servicio profesional con garantía de satisfacción",
    
    standardInstallation: "Instalación Estándar",
    standardInstallationDesc: "Instalación completa de su kit",
    premiumInstallation: "Instalación Premium",
    premiumInstallationDesc: "Servicio completo con personalización",
    remoteConfiguration: "Configuración Remota",
    remoteConfigurationDesc: "Asistencia en línea para configuración",
    mostPopular: "Más Popular",
    reserveService: "Reservar este Servicio",
    
    // Service features
    deviceInstallation: "Instalación de todos los dispositivos",
    networkConfig: "Configuración de red",
    basicTraining: "Capacitación básica",
    support30days: "Soporte 30 días",
    allStandard: "Todo el servicio estándar",
    advancedConfig: "Configuración avanzada",
    customScenarios: "Escenarios personalizados",
    completeTraining: "Capacitación completa",
    support90days: "Soporte 90 días",
    liveVideoSupport: "Soporte de video en vivo",
    softwareConfig: "Configuración de software",
    personalizedGuide: "Guía personalizada",
    support14days: "Soporte 14 días",
    
    whyChooseUs: "¿Por Qué Elegir SmartLogis?",
    localExpertise: "Experiencia Local",
    localExpertiseDesc: "Especialistas en domótica para inquilinos en el área de Montreal",
    quickInstallation: "Instalación Rápida",
    quickInstallationDesc: "Instalación completa en pocas horas, sin modificaciones permanentes",
    continuousSupport: "Soporte Continuo",
    continuousSupportDesc: "Asistencia técnica incluida y garantía de satisfacción 100%",
    
    // Reservation
    reserveYourInstallation: "Reserve su Instalación",
    reservationSubtitle: "Elija la fecha y hora que le convenga para la instalación de su kit",
    selectDateTime: "Seleccione Fecha y Hora",
    appointmentTime: "Hora de cita",
    reservationInfo: "Información de Reserva",
    desiredService: "Servicio deseado",
    chooseService: "Elija un servicio",
    serviceArea: "Área de servicio",
    selectCity: "Seleccione su ciudad",
    fullName: "Nombre completo",
    email: "Correo electrónico",
    phone: "Teléfono",
    fullAddress: "Dirección completa",
    confirmReservation: "Confirmar Reserva",
    allFieldsRequired: "* Todos los campos son obligatorios. Recibirá un correo de confirmación.",
    fillAllFields: "Por favor complete todos los campos",
    reservationConfirmed: "¡Reserva confirmada! Número:",
    confirmationEmailSent: "Se ha enviado un correo de confirmación (verifique los logs del servidor)",
    reservationError: "Error en la reserva. Por favor intente de nuevo.",
    duration: "Duración",
    free: "Gratis",
    
    // Reservation services
    reservationKitBeginner: "Kit Inicial",
    reservationKitComfort: "Kit Confort",
    reservationKitPremium: "Kit Premium",
    reservationCustomKit: "Cotización Kit Personalizado",
    reservationInstallOnly: "Solo Instalación (Equipo del Cliente)",
    reservationPremiumInstallClient: "Instalación Premium (Equipo del Cliente)",
    reservationRemoteConfig: "Configuración Remota",
    
    // Contact
    contactUs: "Contáctenos",
    contactTitle: "Contáctenos",
    contactSubtitle: "¿Tiene alguna pregunta? ¿Necesita una cotización? Nuestro equipo está aquí para ayudarle",
    quoteRequest: "Solicitud de Cotización",
    subject: "Asunto",
    message: "Mensaje",
    sendMessage: "Enviar Mensaje",
    phoneLabel: "Teléfono",
    emailLabel: "Correo",
    serviceZone: "Área de Servicio",
    responseIn24h: "Respuesta en 24h",
    monFri9to6: "Lun-Vie: 9h-18h",
    and30kmAround: "y alrededores (30km)",
    customerTestimonials: "Testimonios de Clientes",
    faq: "Preguntas Frecuentes",
    messageSent: "¡Mensaje enviado! Le responderemos en 24 horas.",
    notificationSent: "Se ha enviado una notificación a ventes@smartlogis.ca (verifique los logs del servidor)",
    messageError: "Error al enviar el mensaje. Por favor intente de nuevo.",
    
    // FAQ
    faqCanITake: "¿Puedo llevarme mi kit cuando me mude?",
    faqCanITakeAnswer: "¡Absolutamente! Esa es la principal ventaja de nuestros kits. Todos nuestros productos son portátiles y pueden ser fácilmente retirados y reinstalados en su nuevo hogar.",
    faqLandlordPermission: "¿Necesito permiso del propietario?",
    faqLandlordPermissionAnswer: "No, nuestras instalaciones no requieren modificaciones permanentes. No se necesita permiso ya que todo puede ser retirado sin dejar rastro.",
    faqServiceArea: "¿Cuál es el área de servicio?",
    faqServiceAreaAnswer: "Servimos Montreal y alrededores (Laval, Longueuil, Orilla Norte, Orilla Sur). Contáctenos para confirmar su dirección.",
    faqWarranty: "¿Ofrecen garantía?",
    faqWarrantyAnswer: "Sí, todos nuestros productos vienen con garantía de 2 años. Nuestro servicio de instalación también incluye soporte técnico gratuito.",
    faqSelfInstall: "¿Puedo instalarlo yo mismo?",
    faqSelfInstallAnswer: "¡Sí! Nuestros kits están diseñados para ser fáciles de instalar. Pero recomendamos nuestro servicio de instalación para una experiencia óptima y configuración personalizada.",
    
    // Footer
    smartHomeSolutions: "Soluciones de hogar inteligente portátiles y asequibles para inquilinos en Montreal y alrededores.",
    quickLinks: "Enlaces Rápidos",
    quebec: "Quebec",
    canada: "Canadá",
    privacyPolicy: "Política de Privacidad",
    termsOfUse: "Términos de Uso",
    allRightsReserved: "Todos los derechos reservados.",

    // Kit Configurator
    configuratorTitle: "Arma tu kit a medida",
    configuratorSubtitle: "Elige tus dispositivos, ve el precio en tiempo real y pide por WhatsApp.",
    ourKits: "Nuestros Kits",
    starterKit: "Kit Inicial",
    intermediateKit: "Kit Intermedio",
    completeKit: "Kit Completo",
    customizeYourKit: "Personaliza tu Kit",
    smartHub: "Hub inteligente",
    sensor: "Sensor",
    remote: "Control remoto",
    smartBulbConfig: "Foco inteligente",
    smartPlugConfig: "Conector inteligente",
    quantity: "Cantidad",
    installationOptions: "Opciones de Instalación",
    basicInstallation: "Instalación básica (1–2 dispositivos)",
    fullInstallation: "Instalación completa",
    totalPrice: "Total",
    orderViaWhatsApp: "Pedir por WhatsApp",
    videoDemo: "Video Demo",
    whatsappGreeting: "¡Hola SmartLogis! Quiero pedir:",
    whatsappTotal: "Total:",
    whatsappThanks: "¡Gracias!",
  }
};
